


export const GraphType = {
    BAR: 1,
    LINE: 2,
    BUBBLE: 3
};

Object.freeze(GraphType);